import type { AnimatedBookCardProps } from "@/components/ui/AnimatedBookCard";

export const publishedBooksHeroContent = {
  eyebrow: "Stories Worth Publishing",
  heading: "Our Published Works",
  subheading:
    "Explore titles produced through expert book publishing, where planning, creativity, and professional eBook publishing turn ideas into measurable impact.",
  primaryCta: {
    label: "+1 (855) 605-5210",
    href: "tel:+18556055210",
  },
  secondaryCta: {
    label: "Talk to a senior consultant",
    href: "#lead",
  },
  backgroundImageSrc: "/published-books/proofreading-banner.webp",
  imageSrc: "/published-books/published-books-bann.webp",
  imageAlt: "Published books showcase",
} as const;

export const publishedBooksGridContent = {
  heading: "Each Manuscript We Handle Becomes a Book That is Ready for the World",
  description:
    "With UBP's book publishing expertise, you can turn your manuscript into a standout book that reaches readers confidently, with professional editing, design, and publishing support every step of the way.",
} as const;

export type PublishedBookItem = Omit<
  AnimatedBookCardProps,
  "className" | "exploreLabel" | "exploreDisabled"
>;

/** True when the book has a dedicated detail page route. */
export function bookHasDetailPage(exploreHref?: string): boolean {
  return Boolean(exploreHref?.startsWith("/") && exploreHref !== "#lead");
}

const c = "/published-books/covers-opt";

export const publishedBooks: PublishedBookItem[] = [
  {
    imageSrc: `${c}/book-port1.webp`,
    imageAlt: "The Verandah a Texas Murder Mystery book cover",
    title: "The Verandah a Texas Murder Mystery",
    author: "Catherine Reese",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/cigar-wars.webp`,
    imageAlt: "Cigar Wars The Spark That Lit The Fire book cover",
    title: "Cigar Wars The Spark That Lit The Fire",
    author: "Desiree Sylver",
    exploreHref: "/cigar-wars-the-spark-that-lit-the-fire",
  },
  {
    imageSrc: `${c}/book-port3.webp`,
    imageAlt: "Ralph And Martha Cahoon book cover",
    title: "Ralph And Martha Cahoon",
    author: "R. Michael Croseen",
    exploreHref: "/ralph-and-martha-cahoon",
  },
  {
    imageSrc: `${c}/allen-court-new.webp`,
    imageAlt: "The Life And Times Of Allen Court book cover",
    title: "The Life And Times Of Allen Court",
    author: "Meshawn Deberry",
    exploreHref: "/the-life-and-times-of-allen-court",
  },
  {
    imageSrc: `${c}/teaching-of-france.webp`,
    imageAlt: "The Teachings of Frances Ring book cover",
    title: "The Teachings of Frances Ring",
    author: "David Bloom",
    exploreHref: "/the-teachings-of-frances-ring",
  },
  {
    imageSrc: `${c}/siya-and-the-coral.webp`,
    imageAlt: "Siya and the Coral book cover",
    title: "Siya and the Coral...",
    author: "Bruce Mangum",
    exploreHref: "/siya-and-the-coral-reef-rescue",
  },
  {
    imageSrc: `${c}/alina-dubrova.webp`,
    imageAlt: "The Name I carry book cover",
    title: "The Name I carry",
    author: "A Designer's",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/julian-hutchinson-front-book-cover.webp`,
    imageAlt: "Jesus Loves Me Now book cover",
    title: "Jesus Loves Me Now",
    author: "Julian Hutchinson",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/tanya-d-front-cover.webp`,
    imageAlt: "By What Authority book cover",
    title: "By What Authority?",
    author: "Tanya D. MCINTIRE",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/the-bounty-hunter.webp`,
    imageAlt: "The Bounty Hunter book cover",
    title: "The Bounty Hunter",
    author: "Robert Felix Sr",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/embracing-love.webp`,
    imageAlt: "Embracing Love book cover",
    title: "Embracing Love",
    author: "Abraham Konateh Kinng",
    exploreHref: "#lead",
  },
  {
    imageSrc: `${c}/through-a-child.webp`,
    imageAlt: "Through a Child's Eyes book cover",
    title: "Through a Child's Eyes..",
    author: "George Leonard Hayes",
    exploreHref: "/through-a-child-eyes",
  },
];
